import { render, staticRenderFns } from "./AuthorizationContract.vue?vue&type=template&id=15f20e6c&scoped=true"
import script from "./AuthorizationContract.vue?vue&type=script&lang=js"
export * from "./AuthorizationContract.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationContract.vue?vue&type=style&index=0&id=15f20e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f20e6c",
  null
  
)

export default component.exports